import { defineModel } from 'foca';

export const walletConnectModel = defineModel('wallet-connect', {
  initialState: {
    openDialog: false,
    showWallet: true,
    addressDomains: {} as Record<string, { domain: string | undefined; time: number }>,
  },
  reducers: {
    toggleDialog(state) {
      state.openDialog = !state.openDialog;
    },
    showWallet(state, show: boolean) {
      state.showWallet = show;
    },
  },
});
